import type { Product } from "@/data/products";
import type { LocaleCode } from "@/i18n/locales";

export function productUrlRef(product: Pick<Product, "id" | "slugUrl">): string {
    return product.slugUrl || product.id;
}

export function productDetailsPath(locale: LocaleCode, product: Pick<Product, "id" | "slugUrl"> | string): string {
    const productRef = typeof product === "string" ? product : productUrlRef(product);
    return `/${encodeURIComponent(locale)}/products/details/${encodeURIComponent(productRef)}`;
}
